export default __webpack_public_path__ + "static/media/incapacitation_10.b1469afe.png";